/**
 * Damaged / lost marker on an admin parcel card. The reason and the money it
 * moved are in the tooltip, so the list stays compact.
 */
const IncidentBadge = ({ incident }) => {
  if (!incident) return null;
  const lost = incident.type === "lost";
  const tip = [
    incident.reason,
    incident.transport_refund > 0
      ? `ტრანსპორტირება დაბრუნდა: ${Number(incident.transport_refund).toFixed(2)} ₾ (${incident.refund_to === "points" ? "ქულებში" : "ბალანსზე"})`
      : null,
    incident.compensation > 0 ? `კომპენსაცია: ${Number(incident.compensation).toFixed(2)} ₾` : null,
    incident.at ? `მონიშნულია ${incident.at}` : null,
  ]
    .filter(Boolean)
    .join("\n");

  return (
    <span
      title={tip}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-bold text-white ${
        lost ? "bg-red-600" : "bg-orange-500"
      }`}
    >
      {lost ? "⛔" : "⚠"} {incident.type_label || (lost ? "დაიკარგა" : "დაზიანდა")}
    </span>
  );
};

export default IncidentBadge;
